// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__zRo__","vCenter":"Skeleton_vCenter__1kVTD"};